export const navigation = {
  en: [
    {
      id: '0',
      title: 'Home',
      uri: '/',
      sublinks: [
        {
          id: '0.1',
          title: 'Profile',
          uri: '/profile',
        },
        {
          id: '0.0',
          title: 'Logout',
          uri: '/logout',
        },
      ],
    },
  ],
  it: [
    {
      id: '0',
      title: 'Home',
      uri: '/',
      sublinks: [
        {
          id: '0.1',
          title: 'Profilo',
          uri: '/profile',
        },
        {
          id: '0.0',
          title: 'Esci',
          uri: '/logout',
        },
      ],
    },
  ],
  de: [
    {
      id: '0',
      title: 'Home',
      uri: '/',
      sublinks: [
        {
          id: '0.1',
          title: 'Profil',
          uri: '/profile',
        },
        {
          id: '0.0',
          title: 'Ausloggen',
          uri: '/logout',
        },
      ],
    },
  ],
};
